<template>
  <div>
    <div>
      <!-- <el-row style="height:120px;background:white" align="middle" type="flex">
        <el-col :span="6">
          <div style="paddingLeft:10px">
            自动报价设置
          </div>
        </el-col>
        <el-col :span="12">
          <p>
            人工审单时间：{{
              this.$moment(autoPriceSet.manualReviewStart).format('HH:mm')
            }}-{{ this.$moment(autoPriceSet.manualReviewEnd).format('HH:mm') }}
            <br/>
            人工审单等待时长：{{ autoPriceSet.manualReviewWait }}分钟<br/>
            免人审金额：{{ autoPriceSet.manualReviewAmount }}元 <br/>
            系统报价时间：
            {{
              this.$moment(autoPriceSet.systemQuotationStart).format('HH:mm')
            }}-{{ this.$moment(autoPriceSet.systemQuotationEnd).format('HH:mm') }}
          </p>
        </el-col>
        <el-col :span="4">
          {{ autoPriceSet.modifyTime }}
        </el-col>
        <el-col :span="2">
          <el-button @click="edit">编辑</el-button>
        </el-col>
      </el-row> -->


      <el-row style="height:120px;background:white" align="middle" type="flex" class="mt10">
        <el-col :span="6">
          <div style="paddingLeft:10px">
            逆向物流设置
          </div>
        </el-col>
        <el-col :span="12">
          <p>
            启用状态: {{ reverseLogistic.status === 1 ? '是' : '否' }}<br/>
            满额当日，自动触发物流条件-金额：{{ reverseLogistic.minAmount }}元<br/>
            未达金额，定时触发物流条件-日期：每月- {{
              dates.join(",")
            }}<br/>
            物流上门时间：
            {{
              reverseLogistic.pickupTime != null ? this.$moment(reverseLogistic.pickupTime[0]).format('HH:mm') : ""
            }}-{{
              reverseLogistic.pickupTime != null ? this.$moment(reverseLogistic.pickupTime[1]).format('HH:mm') : ""
            }}
          </p>
        </el-col>
        <el-col :span="4">
          {{ reverseLogistic.updateTime }}
        </el-col>

        <el-col :span="2">
          <el-button @click="openLogisticsDlg">编辑</el-button>
        </el-col>
      </el-row>
    </div>

    <!-- 修改或新建城市经理对话框 -->
    <el-dialog title="自动报价配置" :visible.sync="isDlg" width="700px">
      <div style="margin: 20px;">
        <div>
          <el-form
              ref="autoPriceSetForm"
              :model="autoPriceSetForm"
              label-width="130px"
          >
            <!-- <el-form-item label="人工审单时间">
              <el-time-picker
                  is-range
                  v-model="autoPriceSetForm.manualReview"
                  format="HH:mm"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  placeholder="选择时间范围"
              >
              </el-time-picker>
            </el-form-item>
            <el-form-item label="人工审单等待时间" prop="manualReviewWait">
              <el-input clearable v-model="autoPriceSetForm.manualReviewWait"
              >
                <template slot="append">分钟</template>
              </el-input
              >
            </el-form-item>
            <el-form-item label="免人审金额: " prop="manualReviewAmount">
              <el-input clearable v-model="autoPriceSetForm.manualReviewAmount"
              >
                <template slot="append">元</template>
              </el-input
              >
            </el-form-item> -->
            <el-form-item label="系统报价时间">
              <el-time-picker
                  is-range
                  v-model="autoPriceSetForm.systemQuotation"
                  format="HH:mm"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  placeholder="选择时间范围"
              >
              </el-time-picker>
            </el-form-item>
          </el-form>
        </div>
        <div style="text-align: center;">
          <el-button
              type="primary"
              style="margin: 30px 20px;"
              @click="submitEdit"
          >确定
          </el-button
          >
          <el-button style="margin: 10px 20px;" @click="closeEditorDlg"
          >暂不
          </el-button
          >
        </div>
      </div>
    </el-dialog>


    <el-dialog title="逆向物流配置" :visible.sync="showLogisticsDlg" width="700px">
      <div style="margin: 20px;">
        <div>
          <el-form
              ref="reverseLogisticForm"
              :model="reverseLogisticForm"
              label-width="230px"
              :rules="rules"
          >
            <el-form-item label="是否开启自动触发">
              <el-switch v-model="reverseLogisticForm.status"></el-switch>
            </el-form-item>
            <!--            <el-form-item label="是否开启自动触发">-->
            <!--              <el-radio-group v-model="autoLogisticForm.status" size="medium">-->
            <!--                <el-radio border label="是" value="true"></el-radio>-->
            <!--                <el-radio border label="否" value="false"></el-radio>-->
            <!--              </el-radio-group>-->
            <!--            </el-form-item>-->
            <el-form-item label="自动触发条件-最低金额: " prop="minAmount" v-show="reverseLogisticForm.status">
              <el-input clearable v-model="reverseLogisticForm.minAmount"
              >
                <template slot="append">元</template>
              </el-input
              >
            </el-form-item>
            <el-form-item label="每月定时触发条件-日期" prop="dates" v-show="reverseLogisticForm.status">
              <el-date-picker
                  type="dates"
                  v-model="reverseLogisticForm.dates"
                  format="dd号"
                  value-format="yyyyMMdd"
                  :picker-options="{
                    disabledDate: function(time) {
                      return time.getDate() > 28 || time.getDate() < 1;
                    }
                  }"
                  placeholder="选择一个或多个日期">
              </el-date-picker>
            </el-form-item>

            <el-form-item label="物流上门时间段" v-show="reverseLogisticForm.status" prop="pickupTime">
              <el-time-picker
                  is-range
                  v-model="reverseLogisticForm.pickupTime"
                  format="HH:mm"
                  value-format="yyyy-MM-dd HH:mm"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  placeholder="选择时间范围"
              >
              </el-time-picker>

            </el-form-item>
          </el-form>
        </div>
        <div style="text-align: center;">
          <el-button
              type="primary"
              style="margin: 30px 20px;"
              @click="submitReverseLogistic"
          >确定
          </el-button
          >
          <el-button style="margin: 10px 20px;" @click="closeLogisticsDlg"
          >暂不
          </el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "autoQuotation",
  components: {},
  data() {
    return {
      isDlg: false,
      key: 'REVERSELOGISTICS',
      showLogisticsDlg: false,
      autoPriceSet: {},
      dates:[],
      reverseLogistic: {
        id: null,
        status: false,
        dates: [],
        minAmount: '',
        pickupStartTime: "",
        PickupEndTime: "",
        pickupTime: null,
        updateTime: '',
      },
      reverseLogisticForm: {
        id: null,
        status: false,
        dates: [],
        minAmount: '',
        pickupStartTime: "11:00",
        PickupEndTime: "12:00",
        pickupTime: null,
        updateTime: '',
      },
      autoPriceSetForm: {
        manualReviewStart: "",
        manualReviewEnd: "",
        systemQuotationStart: "",
        systemQuotationEnd: "",
        manualReview: [],
        systemQuotation: []
      },
      rules: {
        minAmount: [
           {
            validator: (rule, value, callback) => {
              if (this.reverseLogisticForm.status) {
                if (!value) {
                  callback(new Error('请输入最低金额'));
                } else {
                  callback();
                }
              } else {
                callback();
              }
            }
          }
        ],
        dates: [
          {
            validator: (rule, value, callback) => {
              if (this.reverseLogisticForm.status) {
                if (!value) {
                  callback(new Error('请选择日期'));
                } else {
                  callback();
                }
              } else {
                callback();
              }
            }
          }
        ],
        pickupTime: [
          {
            validator: (rule, value, callback) => {
              if (this.reverseLogisticForm.status) {
                if (!value) {
                  callback(new Error('请选择时间'));
                } else {
                  callback();
                }
              } else {
                callback();
              }
            }
          }
        ],
      }
    };
  },
  mounted() {
    // this.getQuoteConfigList();
    this.getReverseLogistics();
  },
  methods: {
    getQuoteConfigList() {
      let self = this;
      self.$api
          .quoteConfigList()
          .then((res) => {
            if (res.code === 200) {
              self.autoPriceSet = res.data;
            }
          });
    },
    getReverseLogistics() {
      let self = this;
      self.$api.getSystemSetting(self.key).then((res) => {
        if (res.code === 200) {
          if (res.data) {
            self.reverseLogistic.status = res.data.status;
            self.reverseLogistic.updateTime = res.data.updateTime;
            let value = JSON.parse(res.data.settingValue);
            self.reverseLogistic.dates = value.dates;
            self.reverseLogistic.minAmount = value.minAmount;
            self.reverseLogistic.pickupTime = value.pickupTime;
            self.reverseLogistic.id = res.data.id;
            console.log(self.$moment(self.reverseLogistic.pickupTime[0]));
            self.dates=self.reverseLogistic.dates.map(item=>{
              return self.$moment(item).format('DD')+'号';
            })
          }
        }
      });
    },
    edit() {
      this.autoPriceSetForm = this.autoPriceSet;
      this.$set(this.autoPriceSetForm, "manualReview", [this.autoPriceSetForm.manualReviewStart, this.autoPriceSetForm.manualReviewEnd]);
      this.$set(this.autoPriceSetForm, "systemQuotation", [this.autoPriceSetForm.systemQuotationStart, this.autoPriceSetForm.systemQuotationEnd]);
      this.isDlg = true;
    },
    openLogisticsDlg() {
      this.reverseLogisticForm.status = this.reverseLogistic.status ==1 ? true :false;
      this.reverseLogisticForm.dates = this.reverseLogistic.dates;
      this.reverseLogisticForm.minAmount = this.reverseLogistic.minAmount;
      this.reverseLogisticForm.pickupStartTime = this.reverseLogistic.pickupStartTime;
      this.reverseLogisticForm.PickupEndTime = this.reverseLogistic.PickupEndTime;
      this.reverseLogisticForm.pickupTime = this.reverseLogistic.pickupTime;
      this.reverseLogisticForm.id=this.reverseLogistic.id;
      this.showLogisticsDlg = true;
    },
    submitReverseLogistic() {
      let self = this;
      let settingValue = {
        dates: this.reverseLogisticForm.dates,
        minAmount: this.reverseLogisticForm.minAmount,
        pickupTime: this.reverseLogisticForm.pickupTime,
      }
      let param = {
        id: this.reverseLogisticForm.id,
        status: this.reverseLogisticForm.status == true ? 1 : 0,
        settingKey: this.key,
        settingValue: JSON.stringify(settingValue)
      }
      self.$api.saveSystemSetting(param).then((res) => {
        if (res.code === 200) {
          this.$message({
            message: "保存成功",
            type: "success",
          });
          self.getReverseLogistics();
          this.showLogisticsDlg = false;
        }
      })
      console.log(param);
    },
    closeLogisticsDlg() {
      this.showLogisticsDlg = false;
    },
    submitEdit() {
      let self = this;
      self.autoPriceSetForm.manualReviewStart = this.$moment(self.autoPriceSetForm.manualReview[0]).format('YYYY-MM-DD HH:mm:ss')
      self.autoPriceSetForm.manualReviewEnd = this.$moment(self.autoPriceSetForm.manualReview[1]).format('YYYY-MM-DD HH:mm:ss')
      self.autoPriceSetForm.systemQuotationStart = this.$moment(self.autoPriceSetForm.systemQuotation[0]).format('YYYY-MM-DD HH:mm:ss')
      self.autoPriceSetForm.systemQuotationEnd = this.$moment(self.autoPriceSetForm.systemQuotation[1]).format('YYYY-MM-DD HH:mm:ss')
      self.$api
          .updateSystemQuoteTime(self.autoPriceSetForm)
          .then((res) => {
            if (res.code === 200) {
              this.$message({
                message: "更新成功",
                type: "success",
              });
              self.getQuoteConfigList();
              this.isDlg = false;
            }
          });

    },
    closeEditorDlg() {
      this.isDlg = false;
    },
  },
};
</script>

<style lang="less">
/*选择日期，年份的隐藏 */
.el-date-picker__header {
  display: none !important;
}

</style>
